import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import "react-dropdown/style.css";
import BaoCaoTongQuanApi from "../../../service/TongChiNhanh/BaoCaoTongQuanApi";
import ReactDOM from "react-dom";

import C3Chart from 'react-c3js';
import 'c3/c3.css';

export const BieuDoHopDong = ({ }) => {



    const [listHopDongYear, setListHopDongYear] = useState([]);
    const [selectHopDongYear, setselectHopDongYear] = useState(new Date().getFullYear());

    const [loadcomplateBieuDoHopDong, setLoadComplateBieuDoHopDong] = useState(true);
    useEffect(() => {
        const currYear = new Date().getFullYear();
        let aNam = [];
        for (var i = currYear; i >= 2015; i--) {
            const option = {
                label: i,
                value: i,
            }
            aNam.push(option);
        }
        setListHopDongYear(aNam);
        LoadBieuDoHopDong(currYear);
    }, []);


    const updateselectHopDongYear = () => (e) => {
        setselectHopDongYear(e.target.value)
        LoadBieuDoHopDong(e.target.value);
    };


    const [chartData1, setChartData1] = useState({
        x: 'x',
        columns: [
            ['x', 'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
            ['Tiền cho vay', 13000000, 19000000, 15000000, 24000000, 4000000, 15000000, 15000000, 16000000, 25000000, 45000000, 15000000, 95000000],
            ['Hợp đồng', 500, 130, 90, 240, 130, 220, 220, 22, 30, 42, 16, 400],
        ],
        type: 'bar',
        types: {
            'Hợp đồng': 'line',
        },
        axes: {
            'Tiền cho vay': 'y',
            'Hợp đồng': 'y2'
        },
        colors: {
            'Tiền cho vay': '#056469',
            'Hợp đồng': '#FF5C00',
        },
    });


    const [chartData, setChartData] = useState({
        x: 'x',
        columns: [],
        type: 'bar',
        types: {
            'Hợp đồng': 'line',
        },
        axes: {
            'Tiền cho vay': 'y',
            'Hợp đồng': 'y2'
        },
        colors: {
            'Tiền cho vay': '#056469',
            'Hợp đồng': '#FF5C00',
        },
    });

    const LoadBieuDoHopDong = (year) => {
        setLoadComplateBieuDoHopDong(false);

        chartData.columns = [];
        let colThang = ['x', 'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'];
        chartData.columns.push(colThang);
        let tienchovay = ['Tiền cho vay'];
        let hopdong = ['Hợp đồng']
        BaoCaoTongQuanApi.BieuDoHopDong(year).then((response) => {
            response.data.map((item, index) => (
                tienchovay.push(item.TongTien),
                hopdong.push(item.SoHopDong)
            ));

            chartData.columns.push(tienchovay);
            chartData.columns.push(hopdong);
            const rootElement = document.getElementById("bieudohopdong")
            ReactDOM.render(<App />, rootElement)

            setLoadComplateBieuDoHopDong(true);
        });

    }

    const App = () => {
        return (
            <div className="App">
                <C3Chart
                    data={chartData}
                    axis={{
                        x: {
                            type: "category",
                        },
                        y: {
                            label: {
                                text: 'Tiền cho vay',
                                position: 'outer-middle'
                            },
                            tick: {
                                format: function (d) { return formatNumber(d); }
                            }
                        },
                        y2: {
                            show: true,

                            label: {
                                text: 'Số lượng hợp đồng',
                                position: 'outer-middle'
                            },

                        }
                    }}
                    bar={{
                        // width: {
                        //     ratio: 0.3
                        // }
                        width: 28
                    }}
                    line={{
                        width: {
                            ratio: 0.3
                        }
                    }}
                    size={{
                        height: 280,
                    }}
                    tooltip={{
                        format: {
                            value: function (value, ratio, id) {
                                return formatNumber(value);
                            }
                        }
                    }}
                />
            </div>
        );
    };

    return (
        <>
            <div className="row" style={{ marginTop: "5px", marginBottom: "10px" }}>
                <div className="col-md-12">
                    <div className="row" style={{ paddingRight: "15px", paddingLeft: "15px" }} >
                        <div className="col-md-12" >
                            <div className="divbaocaochinhanh-cuahang">
                                <div className="row ">
                                    <div className="col-md-12 ">

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="title" style={{ padding: "15px 15px 0px 15px" }}>
                                                    Số lượng hợp đồng, tổng tiền theo tháng
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div style={{ padding: "15px 15px 0px 15px", width: "130px", float: "right" }}>
                                                    {loadcomplateBieuDoHopDong === true ? (<>
                                                        <select
                                                            name="HopDongSearchNam"
                                                            className="selectBox form-control input-sm"
                                                            value={selectHopDongYear}
                                                            onChange={updateselectHopDongYear()}
                                                            style={{ paddingLeft: "28px", backgroundColor: "#2D3748", color: "#FFF", borderRadius: "10px" }}
                                                        >
                                                            {listHopDongYear &&
                                                                listHopDongYear.map((item, idx) => (
                                                                    <option key={"objHopDongYear" + idx} value={item.value}>
                                                                        {item.label}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </>) : (<>
                                                        <select
                                                            name="HopDongSearchNam"
                                                            className="selectBox form-control input-sm"
                                                            value={selectHopDongYear}
                                                            style={{ paddingLeft: "28px", backgroundColor: "#2D3748", color: "#FFF", borderRadius: "10px" }}
                                                            disabled={true}
                                                        >
                                                            {listHopDongYear &&
                                                                listHopDongYear.map((item, idx) => (
                                                                    <option key={"objHopDongYear" + idx} value={item.value}>
                                                                        {item.label}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </>)}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12" style={{ minHeight: "280px", paddingTop: "15px" }}>
                                        <div id="bieudohopdong"></div>
                                    </div>
                                    {loadcomplateBieuDoHopDong === false && (
                                        <>
                                            <div className="warting1">
                                                <div style={{ textAlign: "center", minWidth: "200px" }}>
                                                    Đang thống kê dữ liệu năm {selectHopDongYear}
                                                    <br />
                                                    Vui lòng chờ trong giây lát
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
